// @core/api/endpoints/workflow/set_pipeline_run_as.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SetPipelineRunAsRequest,
  SetPipelineRunAsResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Set or request a pipeline execution identity
 * Performs set operation on pipeline run as.
 */
export async function SetPipelineRunAs(
  pipeline_id: string,
  data: SetPipelineRunAsRequest,
  options?: RequestOptions
): Promise<SetPipelineRunAsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/pipelines/:pipeline_id/run-as`;
  requestPath = requestPath.replace(':pipeline_id', encodeURIComponent(pipeline_id));
  const requestOptions = options;
  return client.post<SetPipelineRunAsResponse>(requestPath, data, requestOptions);
}
